import { useEffect, useState } from 'react';

import type { ContainerType } from '@/views/Events/OrderFulfillment/Components/OrderFulfillmentAddContainerTypes';
import { Communicator } from '@/tools/Communication';

// Module-level cache so multiple mounts share the same data.
let cachedTypes: ContainerType[] = [];
let fetchPromise: Promise<void> | null = null;

function fetchContainerTypes(): Promise<void> {
  if (!fetchPromise) {
    fetchPromise = Communicator.Get('/Container/GetAllContainerCategories', {})
      .then((response) => response.json())
      .then((data: { containerTypes?: ContainerType[] }) => {
        if (data.containerTypes) {
          cachedTypes = data.containerTypes;
        }
      })
      .catch(() => {
        // Allow retry on next mount
        fetchPromise = null;
      });
  }
  return fetchPromise;
}

export function useContainerTypes() {
  const [containerTypes, setContainerTypes] =
    useState<ContainerType[]>(cachedTypes);

  useEffect(() => {
    let isMounted = true;

    fetchContainerTypes().then(() => {
      if (isMounted) setContainerTypes(cachedTypes);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return containerTypes;
}
